import React from "react";

export function shortcutLabel(word, shortcut, options) {
    const { className = "keyboardShortcutHint" } = options ?? {};

    if (options.disabled) {
        return (
            <span>
                {options?.prefix && `${options.prefix} `}
                {word}
                {options?.suffix && ` ${options?.suffix}`}
            </span>
        );
    }

    const regex = new RegExp(shortcut, "i");
    const match = word.match(regex);
    const index = match ? match.index : -1;

    let highlighted = word;

    if (index !== -1) {
        highlighted = (
            <>
                {word.slice(0, index)}
                <span className={className}>{word.slice(index, index + shortcut.length)}</span>
                {word.slice(index + shortcut.length)}
            </>
        );
    }

    return (
        <span>
            {options?.prefix && `${options.prefix} `}
            {highlighted}
            {options?.suffix && `${options.suffix} `}
        </span>
    );
}
